import script from "./NoteCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteCardModal.vue?vue&type=script&setup=true&lang=js"

import "./NoteCardModal.vue?vue&type=style&index=0&id=06dae081&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06dae081"]])

export default __exports__